import React from "react";
import {QuestionarioLojaObject} from "../../../models/Questionario";
import FieldView from "../../../components/FieldView";
import {formDefLoja} from "./forms";
import EntityView from "../../../components/EntityView";
import {FormQuestionarioLoja} from "./FormQuestionarioLoja";
import {EventoObject} from "../../../models/Evento";

interface Props {
  history: any;
  questionario: QuestionarioLojaObject;
  onReload: () => void;
  onDelete: () => Promise<string | void>;
  evento: EventoObject;
  principal: any;
  allowDelete: boolean;
}

export const QuestionarioLoja:React.FC<Props> = (
  {
    questionario, onReload, onDelete, evento, principal,
    allowDelete,
  }
) => {
  return (
    <>
      <EntityView
        instance={questionario}
        ModelForm={FormQuestionarioLoja}
        modelFormProps={{evento, principal}}
        entityLabel="Questionário"
        gender="m"
        onReload={onReload}
        onDelete={onDelete}
        allowDelete={allowDelete}
        allowEdit={allowDelete}
      >
        <div className="text-2xl font-bold mb-4">
          Questionário
        </div>

        <FieldView value={questionario.ultimo_pedido} def={formDefLoja.ultimo_pedido}/>

        <div className="text-xl font-hairline mt-4">Bovigen Repro Total</div>
        <div className="flex flex-wrap">
          <div className="w-1/2">
            <FieldView value={questionario.bovigen_repro_total_quantidade} def={formDefLoja.bovigen_repro_total_quantidade}/>
          </div>
          <div className="w-1/2">
            <FieldView value={questionario.bovigen_repro_total_valor} def={formDefLoja.bovigen_repro_total_valor}/>
          </div>
        </div>

        <div className="text-xl font-hairline mt-4">Bovigen Lepto 8</div>
        <div className="flex flex-wrap">
          <div className="w-1/2">
            <FieldView value={questionario.bovigen_lepto8_quantidade} def={formDefLoja.bovigen_lepto8_quantidade}/>
          </div>
          <div className="w-1/2">
            <FieldView value={questionario.bovigen_lepto8_valor} def={formDefLoja.bovigen_lepto8_valor}/>
          </div>
        </div>

        <div className="text-xl font-hairline mt-4">Bovigen V4J5</div>
        <div className="flex flex-wrap">
          <div className="w-1/2">
            <FieldView value={questionario.bovigen_v4j5_quantidade} def={formDefLoja.bovigen_v4j5_quantidade}/>
          </div>
          <div className="w-1/2">
            <FieldView value={questionario.bovigen_v4j5_valor} def={formDefLoja.bovigen_v4j5_valor}/>
          </div>
        </div>

        <div className="text-xl font-hairline mt-4">Fosfosal</div>
        <div className="flex flex-wrap">
          <div className="w-1/2">
            <FieldView value={questionario.fosfosal_quantidade} def={formDefLoja.fosfosal_quantidade}/>
          </div>
          <div className="w-1/2">
            <FieldView value={questionario.fosfosal_valor} def={formDefLoja.fosfosal_valor}/>
          </div>
        </div>

        <div className="text-xl font-hairline mt-4">
          Observações
        </div>

        <FieldView label="" value={questionario.observacoes}
                   className="text-gray-600"/>
      </EntityView>
    </>
  )
};
